import Swiper from './vue-components/swiper/swiper.vue'
import Column from './vue-components/column/column.vue'
import Img from './vue-components/img/img.vue'
import Article from './vue-components/article/article.vue'
import Footer from './vue-components/footer/footer.vue'
import Header from './vue-components/header/header.vue'
import Pop from './vue-components/pop/pop.vue'
import Alert from './vue-components/pop/alert.vue'
import Alert2 from './vue-components/pop/alert2.vue'
import Tab from './vue-components/tab/tab.vue';

function registerComponents(_Vue) {
    _Vue.component('swiper',Swiper)

    ;[
        ['column', Column],
        ['img', Img],
        ['article', Article],
        ['footer', Footer],
        ['header', Header],
        ['pop', Pop],
        ['alert', Alert],
        ['alert2', Alert2],
        ['tab', Tab]
    ].forEach(c => {
        _Vue.component('j-'+c[0],c[1])
    })
}

export var Vue

export default function(_Vue) {
    Vue = _Vue

    registerComponents(_Vue)
}



// WEBPACK FOOTER //
// ./src/vue-install.js